//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
import MdmLink from '~/components/atoms/MdmLink.vue';
export default {
  name: 'Rebound',
  components: {
    MdmLink
  },
  props: {
    src: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    cta: {
      type: String,
      default: ''
    },
    withIcon: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      mobile: true
    };
  },

  mounted() {
    this.mobile = this.isMobile();
  }

};